import React from "react";
import InfoItem from "../InfoItem/InfoItem";
import {checkEmptyObj, moveElementToEnd} from "helper/common";
import {Divider, Space} from "antd";

const Lens = props => {
  const {data, isShow = true} = props;
  const render = () => {
    return (
      <>
        {isShow && <div className="title">Thủy tinh thể:</div>}
        <Space direction="vertical">
          {moveElementToEnd(
            Object.keys(data || {}).filter(
              key =>
                (data[key] &&
                  key != "show" &&
                  key != "Option" &&
                  key != "NS" &&
                  key != "C" &&
                  key != "P") ||
                key == "Phân loại LOCS"
            ),
            "Ghi chú"
          ).map(key => {
            if (key == "Ghi chú") {
              return (
                <>{data[key] && <InfoItem label={key} value={data[key]} />}</>
              );
            } else if (key == "Phân loại LOCS") {
              return (
                <>
                  {" "}
                  {(data["NS"] || data["C"] || data["P"]) && (
                    <div>
                      • Phân loại LOCS:{" "}
                      {data["NS"] && <span>NS = {data["NS"]}</span>}{" "}
                      {data["C"] && <span>C = {data["C"]}</span>}{" "}
                      {data["P"] && <span>P = {data["P"]}</span>}{" "}
                    </div>
                  )}
                </>
              );
            } else {
              return (
                <InfoItem
                  label={key}
                  value={data[key] == true ? "Có" : data[key]}
                />
              );
            }
          })}
        </Space>
        <Divider className="border-grey"></Divider>
      </>
    );
  };
  return <div className="Lens">{!checkEmptyObj(data) && render()}</div>;
};
export default Lens;
